import React, { useState, useEffect } from "react";
import { Table, TableBody, Paper, Grid } from "@material-ui/core";
import { EngineModuleForm, } from "../components";
import moment from 'moment';
import { withRouter } from 'react-router-dom/cjs/react-router-dom';
import { permissionCheckFnforCamo, checkApiStatus, downloadFileType } from "../../../../utils";
import { AccessDenied, EmptyCollection, PageLoader, DeletePopUp } from "../../../../shared_elements";
import BasicDetailHeader from "../../BasicDetailHeader";
import { globalGetService, globalDeleteService, globalExportService } from '../../../../utils/globalApiServices';
import { trackActivity } from "../../../../utils/mixpanel";
import SubDetails from "../../../../shared_elements/components/sub_details/SubDetails";
import Pagination from '../../../../shared_elements/components/Pagination';
import EngineModuleList from "../components/EngineModuleList";
import EngModuleHd from "../components/EngModuleHd";
import { useSnackbar } from 'notistack'
import CtaAction from "../../../../shared_elements/components/cta/CtaAction";
import ImportFileModule from "../../../../shared_elements/components/import_Format/ImportFileModule";
const EngineModuleComponent = ({ match, props }) => {
	const { enqueueSnackbar, closeSnackbar } = useSnackbar();
	const [pageLoader, setPageLoader] = useState(false)
	const [filter, setFilter] = useState({})
	const [slug, setSlug] = useState("")
	const [sortInfo, setSortInfo] = useState({ sort: '', sort_by: '' });
	const [bulk, setBulk] = useState({ modal: false, ids: [], title: '', type: '' })
	const [data, setData] = useState({ results: [], pagination: {}, asset_count: {}, })
	const [engineCRU, setEngineCRU] = useState({ modal: false, data: null, mode: '' })
	const [deleteList, setDeleteList] = useState({ modal: false, data: null })
	const [importFiles, setImportFiles] = useState({ modal: false, data: null })
	const [basicDetail, setsetBasicDetail] = useState(null)
	const [isBasicDetailExpanded, setIsBasicDetailExpanded] = useState(true)
	useEffect(() => {
		trackActivity('Engine Module Page Visited - CAMO', {
			event_type: 'Page Visited',
			page_title: 'Engine Module',
		})
		getEngModuleList({ per_page: 250 }, 'skeltonLoader')
	}, [])

	const pullData = (slug) => {
		setSlug(slug)
	}
	const basicDetailFn = (esn) => {
		setsetBasicDetail(esn)
	}

	const createSortHandler = (key) => {
		let sortQuery = { sort: key };
		if (sortInfo.sort === key) {
			sortQuery = { ...sortQuery, sort_by: sortInfo.sort_by === 'asc' ? 'desc' : 'asc' }
		} else {
			sortQuery = { ...sortQuery, sort_by: 'asc' }
		}
		setSortInfo(sortQuery)
		getEngModuleList({ ...filter, ...sortQuery, page: 1, per_page: data?.pagination?.per_page }, 'pageLoader');
	}

	const toggleBulkOps = async (flag, type, item) => {
		try {
			if (type === 'bulk') {
				const response = await getEngModuleList({ per_page: flag ? data?.pagination?.total : 250 }, 'pageLoader');
				setBulk({ ...bulk, type: 'bulk', ids: flag ? response.results : [] });
			} else {
				setBulk({ ...bulk, type: 'single', ids: flag ? [...bulk?.ids, item] : bulk?.ids.filter(optionItem => optionItem?.id !== item?.id) })
			}
		} catch (error) {
			console.error("Error fetching data:", error);
		}
	}

	const getEngModuleList = (query, loaderType) => {
		setPageLoader(true)
		return globalGetService(`camo/engine_module/`, { ...query, asset: match?.params?.asset, asset_type: match?.params?.assetType })
			.then((response) => {
				setPageLoader(false)
				if (checkApiStatus) {
					setData(response?.data || [])
					delete query?.page
					delete query?.per_page
					setFilter(query)
				} else {
					setPageLoader(false)
				}
				return response?.data
			})
	}

	const deleteEngList = () => {
		setPageLoader(true)
		globalDeleteService(deleteList?.modal ? `camo/engine_module/${deleteList?.data?.id}/` :
			`camo/engine_module/bulk_delete/${match?.params?.assetType}/${match?.params?.asset}/`,
			deleteList?.modal ? null : { delete_ids: bulk?.ids.map(item => item?.id) })
			.then((response) => {
				setPageLoader(false); setDeleteList({ modal: false, data: null }); getEngModuleList({ per_page: 250 })
				setBulk({ modal: false, ids: [], title: '', type: '' })
				if (checkApiStatus(response)) {
					enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" }, })
					trackActivity('Engine Module -Airworthiness Management', {
						event_type: 'Engine Module -Templates Delete',
						page_title: 'Engine Module - Templates Deleted Success',
						deleted_id: deleteList?.data?.id,
						success_msg: response?.data?.message
					})
				} else {
					enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" }, })
					trackActivity('Engine Module -Airworthiness Management', {
						event_type: 'Engine Module -Templates  Delete ',
						page_title: 'Engine Module -Templates Delete Failed ',
						deleted_id: deleteList?.data?.id,
						error_msg: response?.data?.message
					})
				}

			})
	}
	const exportEng = (extension) => {
		const date = new Date()
		const todayDate = moment(String(date)).format("YYYY-MM-DD")
		setPageLoader(true);
		globalExportService(`/camo/engine_module/${match?.params?.asset}/${match?.params?.assetType}/export/`, { download: extension })
			.then(response => {
				setPageLoader(false);
				downloadFileType(response.data, `${todayDate}_ESN ${basicDetail?.esn || basicDetail?.msn}_EngineModule`, extension)
				enqueueSnackbar("Download Engine Module List Successfully", { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
			});
	}
	const downloadSmpTemplateFn = (extension, type) => {
		const date = new Date()
		const todayDate = moment(String(date)).format("DD-MM-YYYY")
		setPageLoader(true);
		if (type === "template") {
			globalGetService(`camo/template/download/${match?.params?.asset}/17/`,)
				.then(response => {
					if (checkApiStatus(response)) {
						setPageLoader(false);
						window.open(response?.data?.data?.file_path, "_self")
						enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
					} else {
						setPageLoader(false);
						enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });

					}
				});
		} else {
			globalExportService(`camo/engine_module/${match?.params?.asset}/${match?.params?.assetType}/sample/?download=xlsx`)
				.then(response => {
					if (checkApiStatus(response)) {
						setPageLoader(false);
						downloadFileType(response?.data, `Sample_Engine_Module_${basicDetail?.esn || basicDetail?.msn}`, extension)
						enqueueSnackbar("Download sample downloading success", { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
					} else {
						setPageLoader(false);
						enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
					}
				});
		}

	}
	return (
		<section className="amp-listing-section">
			{pageLoader ? <PageLoader /> : null}
			{permissionCheckFnforCamo({ primaryKey: "ad_status", keyIndex: "R" }) ?
				<Grid style={{ marginTop: 0 }} spacing={3} container>
					<Grid style={{ paddingTop: 0, paddingRight: 0 }} xs={12} item>
						<SubDetails
							title="Engine Module"
							slug={slug}
							match={match}
							masterExport={true}
							module='eng_module'
							onRefresh={() => getEngModuleList({ per_page: 250 }, 'pageLoader')}
							permissionCheck={permissionCheckFnforCamo({ primaryKey: "ad_status", keyIndex: "U" })}
						/>
						<BasicDetailHeader props={match} func={pullData} engineType={basicDetailFn} module='eng_module' onAccordionChange={(expanded) => setIsBasicDetailExpanded(expanded)} />
						<Paper square style={{ padding: "5px", marginTop: "10px" }} variant='outlined'>
							<CtaAction
								searchPlaceholder="Search Module Name Section"
								onSearch={(value) => getEngModuleList({ search: value, per_page: 250 })}
								permissionCheck={!permissionCheckFnforCamo({ primaryKey: "ad_status", keyIndex: "C" }) || window?.location?.search.includes('archived-assets')}
								addLabel="ADD ENGINE MODULE"
								onAddFn={() => setEngineCRU({ modal: true, data: null, type: 'add' })}
								onImportFn={() => setImportFiles({ modal: true, data: null })}
								exportMenu={{
									exportReportFn: (file) => exportEng(file?.extension),
									files: [{ title: 'PDF', extension: 'pdf' }, { title: 'EXCEL', extension: 'xlsx' }],
									disabled: !data?.results?.length,
								}}
								downloadSampleMenu={{
									exportReportFn: (file) => downloadSmpTemplateFn(file?.extension, file?.type),
									files: [{ title: 'DOWNLOAD SAMPLE', extension: 'xlsx', type: 'sample' }, { title: 'TEMPLATE', extension: 'xlsx', type: 'template' }],
								}}
							/>
							<div style={{ height: `${window.innerHeight - (isBasicDetailExpanded ? 475 : 290)}px`, overflow: 'auto' }}>
								<Table className='mui-table-format' stickyHeader={true}>
									<EngModuleHd
										sortInfo={sortInfo}
										createSortHandler={createSortHandler}
										toggleBulkOps={toggleBulkOps}
										bulk={bulk}
										data={data}
										deleteallFn={() => setBulk({ modal: true, ids: bulk?.ids, title: '', type: 'bulk' })}
									/>
									<TableBody>
										{data?.results?.map((item, index) =>
											<EngineModuleList
												item={item}
												key={index}
												bulk={bulk}
												toggleBulkOps={toggleBulkOps}
												toggleModalFn={() => setEngineCRU({ modal: true, data: item, type: 'edit' })}
												toggleDelteModalFn={() => setDeleteList({ modal: true, data: item })}
											/>
										)}
									</TableBody>
								</Table>
								{!data?.results?.length ? <EmptyCollection title="No Records Founds" /> : null}
							</div>
							<Pagination
								bulkFlag={data?.pagination?.total === bulk?.ids?.length && data?.pagination?.total > 0}
								pagination={data?.pagination}
								onChangeRowsPerPage={(event) => getEngModuleList({ page: 1, per_page: event.target.value })}
								onChangePage={(event, newPage) => getEngModuleList({ per_page: data.pagination.per_page, page: newPage + 1, })}
							/>
						</Paper>
					</Grid>
				</Grid> : <AccessDenied />}
			{deleteList?.modal || bulk?.modal ?
				<DeletePopUp
					title='Delete Engine Module'
					deleteRecordFn={() => deleteEngList()}
					modal={true}
					content={`Do you really want to delete ${deleteList?.modal ? 'this' : 'these'} record`}
					toggleModalFn={() => bulk?.modal ? setBulk({ modal: false, ids: [], title: '', type: '' }) : setDeleteList({ modal: false })}
				/> : null

			}
			{engineCRU?.modal ?
				<EngineModuleForm
					engModuleData={engineCRU?.data}
					modeType={engineCRU?.type}
					modalCloseFn={() => setEngineCRU({ modal: false, data: null, type: "" })}
					getResponseBack={() => getEngModuleList({ per_page: data?.pagination?.per_page || 250 }, 'pageLoader')}
				/> : null
			}
			{importFiles?.modal ?
				<ImportFileModule
					importUrl={`camo/engine_module/${match?.params?.asset}/${match?.params?.assetType}/import/`}
					title="Import Engine Module"
					getResponseBack={() => getEngModuleList({ per_page: 250 })}
					toggleModalFn={() => setImportFiles({ modal: false })}
				/> : null
			}
		</section>
	)
}
export default withRouter(EngineModuleComponent)
